module.exports = __webpack_public_path__ + "img/QRPaymentCN.e0fdd88f.png";